import { defineCustomElement } from "vue";
import MaterialIconCe from "./MaterialIcon.ce.vue";
import { Register } from "..";

const tag = "vc-material-icon";

const _register: Register = {
  register() {
    customElements.get(tag) ||
      customElements.define(tag, defineCustomElement(MaterialIconCe));
  }
};

export default _register;
